<template>
	<footer class="footer">
		<div class="footer__nav">
			<div class="container">
				<nav class="nav">
					<router-link class="nav-link" to="/changelog">{{ $t('changelog') }}</router-link>
				</nav>
			</div>
		</div>
		<div class="footer__bottom">
			<div class="container">
				<div class="text-center">
					<div class="footer-copyright">{{ $t('copyright') }} &copy; {{ year }} MyMeet</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'SiteFooter',
	computed: {
		year() {
			return new Date().getFullYear();
		},
	},
};
</script>
